export default "__VITE_ASSET__7958c996__"